import { render, staticRenderFns } from "./DetailsTrip.vue?vue&type=template&id=06865e2b&scoped=true&"
import script from "./DetailsTrip.vue?vue&type=script&lang=js&"
export * from "./DetailsTrip.vue?vue&type=script&lang=js&"
import style0 from "./DetailsTrip.vue?vue&type=style&index=0&id=06865e2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06865e2b",
  null
  
)

export default component.exports